module.exports = __webpack_public_path__ + "assets/arrow_left-a331a1.svg";